import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { SavedQuotesTableInterface } from '../../interface';
import { ComboWithOptions, Group, SelectOption } from '../../../../../../shared/interfaces';
import { QuotationGroups } from '../../../../NewQuote/containers';

interface SavedQuotesContextProps {
  allDataTable:                 SavedQuotesTableInterface[];
  
  dataTable:                    SavedQuotesTableInterface[];
  setDataTable:                 Dispatch<SavedQuotesTableInterface[]>;

  groupsList:                   ComboWithOptions[];

  groupsOptionsList:            SelectOption[];

  isLoadingTable:               boolean;
  setIsLoadingTable:            Dispatch<SetStateAction<boolean>>;

  savedQuotesForm:              FormInstance<SavedQuotesTableInterface>;
  
  articleGroups:                Array<Group>;

  getQuotationGroupByArticle:   (articleId: string) => QuotationGroups;
};

export const SavedQuotesContext = createContext({} as SavedQuotesContextProps);
